import styled from "styled-components";
import { DetailLine } from "../../common/commonStyle";

export const DeleteItem = styled.div`
  display: flex;
  padding-left: 16px;
  background-color: #fdfcfb;

  & div {
    font-size: 14px;
    line-height: 20px;
    padding-top: 12px;
    padding-bottom: 12px;
  }
`;

export const ReCommentContainer = styled.div`
  padding-top: 17px;
  padding-left: 16px;
  background-color: #fdfcfb;
`;

export const ReCommentDetailLine = styled(DetailLine)`
  padding-left: -16px;
`;

export const InputComments = styled.div`
  width: calc(100% - 32px);
  padding-left: 12px;
  padding-right: 12px;
  margin-top: 11px;
  margin-bottom: 12px;
  background: #f1f3f5;
  border-radius: 8px;
  box-sizing: border-box;

  & textarea {
    width: 100%;
    border: none;
    outline: none;
    resize: none;
    overflow: hidden;

    font-size: 14px;

    background: #f1f3f5;
    box-sizing: border-box;

    &::placeholder {
      font-size: 14px;
      letter-spacing: -0.02em;
      color: #4a5056;
    }

    &.blur {
      margin-top: 12px;
      margin-bottom: 8px;
    }

    &.focus {
      margin-top: 12px;
      margin-bottom: 8px;
      color: #4a5056;
      caret-color: #ff7a00;

      &::placeholder {
        color: #878e95;
      }
    }
  }

  & .textareaAside {
    display: flex;
    justify-content: space-between;
    padding-bottom: 8px;
    margin-top: 14px;
    color: #4a5056;
    box-sizing: border-box;

    & div {
      font-size: 12px;
    }

    & button {
      border: none;
      outline: none;
      font-size: 14px;
      line-height: 20px;
      cursor: pointer;

      &.orange {
        color: #ff7a00;
        font-weight: 700;
      }

      &.black {
        color: #000;
        font-weight: 400;
      }
    }
  }
`;

export const RecommentMoreContainer = styled.div`
  /* margin-top: -17px; */
  position: relative;
  width: 100%;

  & > div {
    position: absolute;
    right: 0;
    width: 67.77%;

    background-color: rgba(237, 237, 237, 0.8);
    border-radius: 12px;
    box-sizing: border-box;

    filter: drop-shadow(0px 8px 64px rgba(0, 0, 0, 0.08));
    backdrop-filter: blur(80px);

    & div {
      padding: 11px 16px;
      font-weight: 500;
      cursor: pointer;
      color: #000;

      border-bottom: 0.5px solid rgba(60, 60, 67, 0.36);
    }

    & :last-child {
      border: none;
    }
  }
`;
